{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "tracking_status",
  "x-cli-editable": true,
  "title": "Tracking Status",
  "description": "Staff-only: manual inventory of CTA conversion tracking verification and internal notes.",
  "type": "object",
  "properties": {
    "staff_notes": {
      "ui:sectionTitle": "Tracking Notes",
      "ui:sectionDescription": "Staff notes on this domain's tracking setup.",
      "ui:sectionIcon": "FileText",
      "type": [
        "string",
        "null"
      ],
      "x-access": "staff",
      "ui:description": "Internal staff notes about this domain's tracking setup",
      "ui:widget": "textarea",
      "maxLength": 2000
    },
    "traffic_notes": {
      "type": [
        "string",
        "null"
      ],
      "x-access": "staff",
      "ui:description": "Internal staff notes about this domain's traffic (volume, quality, cookie/GTM context)",
      "ui:widget": "textarea",
      "maxLength": 2000
    },
    "tracking_inventory": {
      "type": "array",
      "x-access": "staff",
      "ui:description": "Manual inventory of CTA conversion tracking verification",
      "maxItems": 20,
      "items": {
        "type": "object",
        "properties": {
          "name": {
            "type": "string",
            "ui:description": "CTA name (e.g. 'Demo', 'Free Trial')",
            "maxLength": 100
          },
          "site_no_interaction_rose_tracks": {
            "type": "string",
            "enum": [
              "working",
              "not_working",
              "unknown"
            ],
            "default": "unknown",
            "ui:description": "Can Rose detect a conversion when the visitor clicks the site CTA without any Rose interaction?"
          },
          "site_no_interaction_client_tracks": {
            "type": "string",
            "enum": [
              "working",
              "not_working",
              "unknown"
            ],
            "default": "unknown",
            "ui:description": "Can the client's analytics detect a conversion from the site CTA without any Rose interaction?"
          },
          "site_with_interaction_rose_tracks": {
            "type": "string",
            "enum": [
              "working",
              "not_working",
              "unknown"
            ],
            "default": "unknown",
            "ui:description": "Can Rose detect a conversion when the visitor clicks the site CTA after chatting with Rose?"
          },
          "site_with_interaction_client_tracks": {
            "type": "string",
            "enum": [
              "working",
              "not_working",
              "unknown"
            ],
            "default": "unknown",
            "ui:description": "Can the client's analytics detect a conversion from the site CTA after chatting with Rose?"
          },
          "widget_cta_rose_tracks": {
            "type": "string",
            "enum": [
              "working",
              "not_working",
              "unknown"
            ],
            "default": "unknown",
            "ui:description": "Can Rose detect a conversion when the visitor clicks the CTA from within the Rose widget?"
          },
          "widget_cta_client_tracks": {
            "type": "string",
            "enum": [
              "working",
              "not_working",
              "unknown"
            ],
            "default": "unknown",
            "ui:description": "Can the client's analytics detect a conversion from the Rose widget CTA?"
          },
          "strategy": {
            "type": [
              "string",
              "null"
            ],
            "ui:description": "Detection strategy used (e.g. cta_page_form, thankyou_page)",
            "maxLength": 100
          },
          "notes": {
            "type": [
              "string",
              "null"
            ],
            "ui:description": "Notes about this CTA's tracking setup",
            "maxLength": 500
          }
        },
        "required": [
          "name"
        ]
      }
    }
  },
  "default": {
    "staff_notes": null,
    "traffic_notes": null,
    "tracking_inventory": []
  }
}
